import auth0Client from "@/auth0";
import envService from "@/env.service";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import axios, { HttpStatusCode } from "axios";

// Create an Axios instance
const axiosInstance: AxiosInstance = axios.create({
  baseURL: envService.env.api.url,
  timeout: 10000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(async (config) => {
  try {
    const token = await auth0Client.getTokenSilently();
    config.headers.Authorization = `Bearer ${token}`;
  } catch (error) {
    console.error("Error getting access token", error);
    await auth0Client.loginWithRedirect();
  }
  return config;
});

// Add a response interceptor (optional, for error handling)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === HttpStatusCode.Forbidden &&
      error.response?.data?.error === "user_deactivated"
    ) {
      window.location.href = "/deactivated";
    }

    return Promise.reject(error);
  },
);

// Function to handle requests with cancellation
export const customAxiosInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const source = axios.CancelToken.source();
  const promise = axiosInstance({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }) => {
    return data;
  });

  // @ts-ignore
  promise.cancel = () => {
    source.cancel("Query was cancelled");
  };

  return promise;
};

export default axiosInstance;
